"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactUsPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const helpers_1 = require("../../utils/helpers");
const rest_provider_1 = require("../../utils/rest_provider");
const alert_box_1 = require("../../widgets/alert_box");
const form_for_1 = require("../../widgets/form_for");
let contactUs = {
    title: "",
    message: ""
};
const provider = new rest_provider_1.RestProvider({
    create: "POST|/contact_us",
    delete: "",
    index: "",
    name: "contact_us",
    new: "",
    show: "",
    update: ""
});
let sent = false;
exports.ContactUsPage = {
    oncreate() {
        contactUs = { title: "", message: "" };
        sent = false;
    },
    viewSent() {
        return (0, mithril_1.default)("div", { style: "text-align: center; font-size: 1.25em" }, mithril_1.default.trust("Merci pour votre message<br>Nous vous répondrons dans les plus brefs délais."));
    },
    viewForm() {
        return (0, form_for_1.formFor)(contactUs, provider, (cb) => {
            return (0, mithril_1.default)("div", cb.errorBlock(), cb.field("Titre", "title", "text"), cb.textarea("Votre message", "message"), cb.submit("Envoyer", {
                onsubmit: (_obj) => { sent = true; }
            }));
        });
    },
    view() {
        return (0, mithril_1.default)(".container.content.phone-padding", (0, mithril_1.default)("h2", "Contactez-nous"), (0, mithril_1.default)("p", mithril_1.default.trust(`Une question ou une requete?<br>
        Écrivez nous sur <a href="mailto:${app_1.App.getSettings("email")}" target="_blank">${app_1.App.getSettings("email")}</a><br>
        Vous pouvez aussi nous contacter par téléphone au <strong>${app_1.App.getSettings("phone_number")}</strong> ou remplir le formulaire ci-dessous.<br>
        `), (0, mithril_1.default)(".mh10", (0, alert_box_1.alertBox)({
            content: (0, mithril_1.default)("a", { href: app_1.App.getSettings("new_contract_request_link"), target: "_blank" }, (0, helpers_1.iconSpan)("fa-info"), "Pour tout renouvellement de forfaits, veuillez remplir le formulaire ci-joint"),
            level: "light",
        }))), (0, mithril_1.default)("hr"), sent ? this.viewSent() : this.viewForm());
    }
};
